var _polyline, _polyline2, _polyline3, _polyline4, _polyline5, _polyline6, _polyline7, _polyline8, _polyline9, _polyline10, _polyline11, _polyline12;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRotatingLines(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "rotating-lines",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: 100,
    stroke: "currentColor",
    speed: 0.75,
    role: "status",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "24,12 24,4",
    width: 5,
    transform: "rotate(0, 24, 24)"
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    points: "24,12 24,4",
    width: 5,
    transform: "rotate(30, 24, 24)"
  })), _polyline3 || (_polyline3 = /*#__PURE__*/React.createElement("polyline", {
    points: "24,12 24,4",
    width: 5,
    transform: "rotate(60, 24, 24)"
  })), _polyline4 || (_polyline4 = /*#__PURE__*/React.createElement("polyline", {
    points: "24,12 24,4",
    width: 5,
    transform: "rotate(90, 24, 24)"
  })), _polyline5 || (_polyline5 = /*#__PURE__*/React.createElement("polyline", {
    points: "24,12 24,4",
    width: 5,
    transform: "rotate(120, 24, 24)"
  })), _polyline6 || (_polyline6 = /*#__PURE__*/React.createElement("polyline", {
    points: "24,12 24,4",
    width: 5,
    transform: "rotate(150, 24, 24)"
  })), _polyline7 || (_polyline7 = /*#__PURE__*/React.createElement("polyline", {
    points: "24,12 24,4",
    width: 5,
    transform: "rotate(180, 24, 24)"
  })), _polyline8 || (_polyline8 = /*#__PURE__*/React.createElement("polyline", {
    points: "24,12 24,4",
    width: 5,
    transform: "rotate(210, 24, 24)"
  })), _polyline9 || (_polyline9 = /*#__PURE__*/React.createElement("polyline", {
    points: "24,12 24,4",
    width: 5,
    transform: "rotate(240, 24, 24)"
  })), _polyline10 || (_polyline10 = /*#__PURE__*/React.createElement("polyline", {
    points: "24,12 24,4",
    width: 5,
    transform: "rotate(270, 24, 24)"
  })), _polyline11 || (_polyline11 = /*#__PURE__*/React.createElement("polyline", {
    points: "24,12 24,4",
    width: 5,
    transform: "rotate(300, 24, 24)"
  })), _polyline12 || (_polyline12 = /*#__PURE__*/React.createElement("polyline", {
    points: "24,12 24,4",
    width: 5,
    transform: "rotate(330, 24, 24)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRotatingLines);
export default __webpack_public_path__ + "static/media/rotating-lines.7082bba6.svg";
export { ForwardRef as ReactComponent };